import React from "react";
import "./categories-section.css";
import { Link } from "react-router-dom";
import type { Category } from "@/data/categories";
import type { LocaleCode } from "@/i18n/locales";
import type { InterpolationValues } from "@/i18n/types";
import { CategoryIcon } from "@/components/ui-components/category-icon/category-icon";
import { Icon } from "@/components/ui-components/icon";

export function CategoriesSection({ categories, locale, t }: { categories: Category[]; locale: LocaleCode; t: (key: string, values?: InterpolationValues) => string }) {
    return (
        <section className="section" id="categories">
            <div className="section-head"><div><span className="section-kicker">{t("home.categories.kicker")}</span><p>{t("home.categories.description")}</p></div><Link className="section-link" to={`/${locale}/categories`}>{t("home.categories.viewAll")} <Icon name="arrow-right" size="sm" /></Link></div>
            <div className="category-grid">{categories.map(category => {
                const label = category.name ?? (category.translationKey ? t(category.translationKey) : category.id);
                return <Link className={`category-card${category.featured ? " featured" : ""}`} to={`/${locale}/products/${category.id}`} key={category.id}><span className="category-marker"><CategoryIcon categoryId={category.id} /></span><span className="category-card__copy"><strong>{label}</strong><small>{t("home.categories.products", { count: category.count })}</small></span></Link>;
            })}</div>
        </section>
    );
}
